<template>
  <AccordionItem :class="$style.root">
    <div ref="root">
      <AccordionHeader :class="$style.header">
        <AccordionTrigger :class="$style.trigger">
          {{ item?.label?.trim() }}
          <div :class="$style.buttonContainer">
            <div :class="$style.button" data-outline>
              <SvgoPlus :class="$style.plus" />
              <SvgoMinus :class="$style.minus" />
            </div>
          </div>
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionContent :class="$style.content">
        <CoreTextComponent
          v-if="item?.value"
          :string="item?.value"
          :class="$style.text"
        />
      </AccordionContent>
    </div>
  </AccordionItem>
</template>

<script lang="ts" setup>
const root = ref(null)

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  active: {
    type: Boolean,
    required: false
  }
})
</script>

<style module>
.root {}

.root:not(:last-of-type) {
  border-bottom: var(--stroke--default) solid var(--color--primary);
}

.header {
  composes: reset-heading from global;
}

.header:hover,
.header[data-state="open"] {
}

.trigger {
  composes: reset-button from global;

  width: 100%;
  text-align: left;

  display: grid;
  grid-template-columns: 1fr 1.25em;
  gap: var(--unit--horizontal);
  align-items: center;

  padding-top: calc(var(--padding--element--top) * 2);
  padding-bottom: calc(var(--padding--element--bottom) * 2);
}

.content {
  margin-left: 0;
  overflow: hidden;
}

.content[data-state="open"] {
  animation: slideDown 300ms ease-out;
}
.content[data-state="closed"] {
  animation: slideUp 300ms ease-out;
}

.buttonContainer {
  position: relative;
}

.button {
  composes: button-round from global;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.trigger[data-state="open"] .plus {
  display: none;
}

.trigger[data-state="closed"] .minus {
  display: none;
}

.text {
  margin-top: calc(var(--unit--vertical) - (var(--padding--element--top) * 2));
  margin-bottom: var(--unit--vertical);

  --core-text--heading--font-size: var(--font-small--font-size);
  --core-text--heading--line-height: var(--font-small--line-height);
  --core-text--heading--letter-spacing: var(--font-small--letter-spacing);
}

.plus,
.minus {
  width: 100%;
  stroke: currentColor;
  stroke-width: var(--stroke--default);
}

@keyframes slideDown {
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}

@keyframes slideUp {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
}

/* .label::-webkit-details-marker,
.label::marker {
  font-size: 0px;
  line-height: 0;
  display: none;
}

.label {
  composes: font-size-default from global;
  padding: var(--padding--element);
  padding-bottom: calc(var(--padding--element--bottom) * .35);
  padding-left: 0;
  padding-right: 0;
  cursor: pointer;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--unit--default);

  user-select: none;
}

.root[open] .label,
.label:hover {
}

.richText {
  composes: font-size-default from global;
  padding: var(--padding--element);
  padding-bottom: calc(var(--padding--element--bottom) * .35);
  padding-top: var(--lh, 1em);
  padding-left: 0;
  padding-right: 0;
}

.root:not([open]) .minus {
  display: none;
}

.root[open] .cross {
  display: none;
}

.cross, .minus {
  height: calc(var(--fs, 1rem) * .5);
  overflow: visible;

  fill: currentColor;
  stroke: currentColor;
  stroke-width: .075em;

  align-self: center;

  transform: translateY(calc((var(--padding--element--bottom) * .35) * -1))
} */
</style>
